/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileExeLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FileExeLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m54.466 21.492.176 1.056c.609 3.652.02 8.137-2.213 11.95-2.263 3.865-6.195 6.994-12.11 7.839l-.743.106-6.06-6.061.105-.743c.846-5.915 3.974-9.847 7.839-12.11 3.813-2.234 8.298-2.822 11.95-2.213l1.056.176Zm-2.647 2.647c-2.8-.231-6.057.347-8.843 1.978-2.953 1.73-5.417 4.662-6.265 9.218l3.912 3.912c4.556-.848 7.488-3.312 9.218-6.265 1.631-2.786 2.21-6.044 1.978-8.843Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M47.506 28.452c-.952-.952-1.877-.952-2.828 0-.952.951-.952 1.877 0 2.828.951.952 1.876.952 2.828 0 .952-.951.952-1.877 0-2.828Zm-12.244-2.157 5.678-.167c-1.533 1.11-4.793 4.143-5.573 7.391l-6.246 2.004L27 33.4l6.229-6.228a3 3 0 0 1 2.033-.878Zm14.4 14.401.167-5.678c-.985 1.407-3.842 4.492-7.39 5.572l-2.004 6.246 2.121 2.122 6.229-6.229a3 3 0 0 0 .877-2.033Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m32.303 41.533 8.486-8.485 2.12 2.121-8.484 8.485-2.122-2.121Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M20.88 48.105 28.058 41l2.11 2.131-7.178 7.105-2.11-2.131Zm6.796 2.935 5.217-5.147L35 48.028l-5.217 5.148-2.107-2.136Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m54.466 21.492.176 1.056c.174 1.041.25 2.15.219 3.291a16.799 16.799 0 0 0-.219-2.29l-.176-1.057-1.056-.177c-3.652-.608-8.137-.02-11.95 2.214a15.904 15.904 0 0 0-3.423 2.685l-2.775.081a3 3 0 0 0-2.033.878l-5.73 5.729-.5-.5 6.23-6.23a3 3 0 0 1 2.033-.877l2.775-.081a15.904 15.904 0 0 1 3.423-2.685c3.813-2.234 8.298-2.822 11.95-2.213l1.056.176ZM33.714 35.05c-.033.194-.064.39-.093.59l-.106.742.126.125c.078-.524.174-1.033.288-1.526l-.215.069Zm1.271 3.801-2.682 2.682.5.5 2.682-2.682-.5-.5Zm6.647 4.254-1.197 3.731.243.243 1.299-4.05c-.114.026-.23.052-.345.076Zm.778-7.435.5-.5-2.121-2.122-3.183 3.182-.72-.72c-.064.269-.123.544-.175.825l.895.895 3.182-3.182 1.622 1.621Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m40.228 38.851-.5.5.895.896c4.556-.848 7.488-3.312 9.218-6.265 1.497-2.556 2.107-5.51 2.018-8.142-.078 2.364-.708 4.905-2.018 7.142-1.73 2.953-4.662 5.417-9.218 6.265l-.395-.396Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M47.506 28.452c-.952-.952-1.877-.952-2.828 0-.645.644-.853 1.277-.624 1.914.109-.303.317-.607.624-.914.951-.952 1.876-.952 2.828 0 .307.307.515.61.624.914.229-.637.02-1.27-.624-1.914ZM20.88 48.105 28.058 41l2.11 2.131-.5.495L28.058 42l-6.678 6.61-.5-.505Zm12.013-2.212-5.217 5.148.5.506 4.717-4.654 1.607 1.629.5-.494-2.107-2.135Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileExeLarge
};
